module.exports = "@media (max-width: 667px){.social-card.card{width:100% !important}}\n.day{margin:0 auto}\n"